import React from "react";
import { Textarea } from "./ui/textarea";
import { StickyNote } from "lucide-react";

export default function NotesCard({ value, onChange, disabled = false, hint }) {
  return (
    <div className="surface p-6 space-y-3" data-testid="notes-card">
      <div className="flex items-center gap-2">
        <StickyNote size={16} className="text-[var(--primary)]" />
        <div className="heading text-lg font-semibold">Notatki</div>
      </div>
      <Textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={hint || "Uwagi, ustalenia, wymiary, kolory, terminy..."}
        rows={4}
        className="resize-y min-h-[100px]"
        data-testid="field-notes"
      />
    </div>
  );
}
